import { appNavigationFeature } from './app-navigation.reducer';

export const { selectNavigationHidden, selectNavigationMenu, selectNavigationOpened, selectNavigationSearch } = appNavigationFeature;
